
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 62.583 62.583"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M52.69 52.824a1.5 1.5 0 01-1.501-1.5c0-9.578-7.792-17.371-17.371-17.371s-17.372 7.793-17.372 17.371a1.5 1.5 0 11-3 0c0-11.232 9.139-20.371 20.372-20.371s20.371 9.139 20.371 20.371a1.5 1.5 0 01-1.499 1.5z"}}),_c('path',{attrs:{"d":"M33.818 33.393c-6.516 0-11.817-5.301-11.817-11.817 0-6.515 5.301-11.816 11.817-11.816s11.817 5.301 11.817 11.816c0 6.516-5.301 11.817-11.817 11.817zm0-20.633c-4.862 0-8.817 3.955-8.817 8.816 0 4.862 3.955 8.817 8.817 8.817s8.817-3.955 8.817-8.817c0-4.861-3.955-8.816-8.817-8.816zM13.045 48.51H1.5a1.5 1.5 0 01-1.5-1.5c0-9.665 7.319-16.953 17.025-16.953 2.963 0 5.893.825 8.708 2.453a1.501 1.501 0 01-1.502 2.598c-2.353-1.362-4.777-2.051-7.206-2.051-7.484 0-13.247 5.256-13.952 12.453h9.972a1.5 1.5 0 010 3z"}}),_c('path',{attrs:{"d":"M17.095 32.811c-5.529 0-10.026-4.498-10.026-10.026S11.566 12.76 17.095 12.76a9.962 9.962 0 017.089 2.936 1.5 1.5 0 01-2.121 2.122 6.981 6.981 0 00-4.968-2.058c-3.874 0-7.026 3.151-7.026 7.025 0 3.873 3.152 7.026 7.026 7.026a7.035 7.035 0 005.778-3.029 1.5 1.5 0 112.465 1.709 10.039 10.039 0 01-8.243 4.32zM61.083 48.51h-8.038a1.5 1.5 0 010-3h6.456c-.705-6.411-5.881-11.581-12.588-12.307a1.499 1.499 0 01-.136-2.961c3.345-.675 5.681-3.466 5.681-6.789 0-3.819-3.603-7.297-7.56-7.297a1.5 1.5 0 110-3c5.625 0 10.56 4.812 10.56 10.297a9.79 9.79 0 01-3.845 7.818c6.482 2.469 10.97 8.626 10.97 15.739a1.5 1.5 0 01-1.5 1.5z"}})])
          )
        }
      }
    